import { createAction, props } from '@ngrx/store';
import { SavedReport } from './saved-reports.model';


export const savedReportsLoaded = createAction('[Saved Reports] loaded', props<{ savedReports: SavedReport[] }>());

export const loadSavedReports = createAction('[Saved Reports] load');
